import { Directive, ElementRef, Input, OnInit, NgZone } from '@angular/core';

@Directive({
    selector: '[focusInvalidInput]',
    standalone: false
})
export class FormDirective implements OnInit {
    @Input() focusInvalidInput: any;
    constructor(private el: ElementRef, private ngZone: NgZone) {

    }

    ngOnInit() {
        if (this.focusInvalidInput) {
        console.log("this.focusInvalidInput at directive", this.focusInvalidInput);
            this.ngZone.runOutsideAngular(() => {
                // document.addEventListener(
                //     'submit',
                //     this.onFormSubmit.bind(this)
                // );
                this.el.nativeElement.addEventListener('submit', this.onFormSubmit.bind(this));
            })
        }
    }

    onFormSubmit() {
        const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
        if (invalidControl) {
            // this.ngZone.run(() => {
            invalidControl.focus();
            invalidControl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',   // centers the element vertically
                inline: 'nearest'  // aligns horizontally if needed
              });
            //  })
        }
    }
}